export default "__VITE_ASSET__CWcR$BjJ__"